import React, { useState, useEffect, useRef } from "react";
import { viewIcon } from "../../Icons/Icons";
import EmployeePayslipData from "./EmployeePayslipData";
import { toast } from "react-toastify";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { PAYROLL_STATUS } from "../../../src/redux/constants/payrollComponents";
const EmployeeGenereratedPayrollData = ({
  employeeList = [],
  selectedEmployees = [],
  setSelectedEmployees = () => {},
  month,
  year,
}) => {
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [isPayslipViewOpen, setIsPayslipViewOpen] = useState(false);
  const selectAllRef = useRef();

  const allSelected =
    employeeList.length > 0 &&
    employeeList.every((emp) => selectedEmployees.includes(emp.employee_id));

  const isIndeterminate = selectedEmployees.length > 0 && !allSelected;

  useEffect(() => {
    if (selectAllRef.current) {
      selectAllRef.current.indeterminate = isIndeterminate;
    }
  }, [isIndeterminate]);

  const handleEmployeeSelect = (id, isChecked) => {
    if (isChecked) {
      setSelectedEmployees((prev) => [...prev, id]);
    } else {
      setSelectedEmployees((prev) => prev.filter((empId) => empId !== id));
    }
  };

  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      const allIds = employeeList.map((emp) => emp.employee_id);
      setSelectedEmployees(allIds);
    } else {
      setSelectedEmployees([]);
    }
  };

  const handleViewClick = (employee) => {
    setSelectedEmployee(employee);
    setIsPayslipViewOpen(true);
  };

  const handleClosePayslipView = () => {
    setSelectedEmployee(null);
    setIsPayslipViewOpen(false);
  };
  const axiosPrivate = useAxiosPrivate();
  const handleDownloadPayslip = async (employeeId,month,year ) => {
    try {
      const response = await axiosPrivate.get(
        "/payroll/generateEmployeePayslip",
        {
          params: { employee_id: employeeId , month: month, year: year },
          responseType: "blob",
        }
      );

      if (response?.status === 200) {
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        const filename = `payslip_${employeeId}.pdf`;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        toast.success("Payslip downloaded successfully");
      } else {
        toast.error("Error while downloading the payslip");
      }
    } catch (error) {
      toast.error("Failed to download the payslip. Please try again later.");
    }
  };

  const getPayrollSummary = (payrollDetails = []) => {
    let earnings = 0;
    let deductions = 0;
    let netSalary = 0;

    payrollDetails.forEach((item) => {
      const value = parseFloat(item.calculated_value || 0);
      if (item.component_name === "Total Earnings") {
        earnings += value;
      } else if (item.component_name === "Total Deductions") {
        deductions += value;
      } else if (item.component_name === "Net Pay") {
        netSalary += value;
      }
    });

    const netPay = earnings - deductions;
    return {
      earnings: earnings.toFixed(2),
      deductions: deductions.toFixed(2),
      netSalary: netSalary.toFixed(2),
    };
  };

  if (isPayslipViewOpen && selectedEmployee) {
    return (
      <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4 overflow-auto">
        <div className="bg-white rounded-lg shadow-lg max-w-5xl w-full max-h-[90vh] overflow-y-auto">
          <EmployeePayslipData
            employee={selectedEmployee}
            onClose={handleClosePayslipView}
            selectedEmployeeIds={selectedEmployees}
            employeeList={employeeList}
            setSelectedEmployeeIds={setSelectedEmployees}
            month={month}
            year={year}
            handleDownloadPayslip={handleDownloadPayslip}
          />
        </div>
      </div>
    );
  }
const getPayrollStatusClass = (status) => {
  switch (status) {
    case PAYROLL_STATUS.PUBLISHED:
      return "status--green"; 
    case PAYROLL_STATUS.GENERATED:
      return "status--orange";
    case PAYROLL_STATUS.PENDING:
      return "status--gray";
    default:
      return "status--yellow";
  }
};

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-sm text-gray-500">
        <thead className="text-xs font-medium uppercase bg-gray-50 text-[#4B5563] border-b border-t tracking-wider">
          <tr>
            <th className="px-6 py-3 text-center border-r">
              <input
                type="checkbox"
                ref={selectAllRef}
                checked={allSelected}
                onChange={(e) => handleSelectAll(e.target.checked)}
              />
            </th>
            <th className="px-6 py-3 text-left border-r">Employee Serial</th>
            <th className="px-6 py-3 text-left border-r">Employee</th>

            {/* <th className="px-6 py-3 text-center border-r">Total Earnings</th>
            <th className="px-6 py-3 text-center border-r">Total Deductions</th>
            <th className="px-6 py-3 text-center border-r">Net Pay</th> */}
            <th className="px-6 py-3 text-center border-r">Status</th>
            <th className="px-6 py-3 text-center sticky right-0 bg-gray-50 z-20 border-r">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {employeeList.length > 0 ? (
            employeeList.map((emp, index) => {
              const empName = `${emp.first_name} ${emp.last_name}`;
              const summary = getPayrollSummary(emp.payroll_details || []);
              return (
                <tr key={index} className="bg-white border-b text-center">
                  <td className="px-6 py-4">
                    <input
                      type="checkbox"
                      checked={selectedEmployees.includes(emp.employee_id)}
                      onChange={(e) =>
                        handleEmployeeSelect(emp.employee_id, e.target.checked)
                      }
                    />
                  </td>
                  <td className="px-6 py-4 text-left">
                    {emp?.employee_serial}
                  </td>
                  <td className="px-6 py-4 text-left">{empName}</td>

                  {/* <td className="px-6 py-4">{summary.earnings}</td>
                  <td className="px-6 py-4">{summary.deductions}</td>
                  <td className="px-6 py-4">{summary.netSalary}</td> */}
                  <td className="px-6 py-4">
                    <span
                      className={`status ${getPayrollStatusClass(
                        emp?.payroll_status
                      )}`}
                    >
                      {emp?.payroll_status || "N/A"}
                    </span>
                  </td>
                  <td className="px-6 py-4 sticky right-0 bg-white z-10">
                    <div className="flex items-center justify-center gap-5">
                      <button onClick={() => handleViewClick(emp)}>
                        {viewIcon}
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={8} className="text-center py-4">
                No employee data available.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default EmployeeGenereratedPayrollData;
